import { RouteRecordRaw } from "vue-router";

export const dashboardRoutes: Array<RouteRecordRaw> = [
  {
    path: "/dashboard",
    name: "Dashboard",
    component: () => import("./layouts/DashboardLayout.vue"),
    meta: {
      title: "Panel",
      requiresAuth: true,
    },
    children: [
      {
        path: "", // Ruta por defecto (/dashboard)
        name: "DashboardHome",
        component: () => import("./views/HomeView.vue"),
        meta: { title: "Inicio" },
      },
      {
        path: "empresas",
        name: "CompaniesAdmin",
        component: () => import("../admin/companies/views/CompaniesView.vue"),
        meta: { title: "Empresas" },
      },
      {
        path: "sedes",
        name: "BranchesAdmin",
        component: () => import("../admin/branches/views/BranchesView.vue"),
        meta: { title: "Sedes" },
      },
      {
        path: "empleados",
        name: "EmployeesAdmin",
        component: () => import("../admin/employees/views/EmployeesView.vue"),
        meta: { title: "Empleados" },
      },
      {
        path: "departamentos",
        name: "DepartmentsAdmin",
        component: () =>
          import("../admin/departments/views/DepartmentsView.vue"),
        meta: { title: "Departamentos" },
      },
      {
        path: "puestos",
        name: "PositionsAdmin",
        component: () => import("../admin/positions/views/PositionsView.vue"),
        meta: { title: "Puestos" },
      },
      {
        path: "horarios",
        name: "SchedulesAdmin",
        component: () => import("../admin/schedules/views/SchedulesView.vue"),
        meta: { title: "Horarios" },
      },
      {
        path: "bitacora",
        name: "BitacoraAdmin",
        component: () =>
          import("../admin/records/bitacora/views/BitacoraView.vue"),
        meta: { title: "Bitácora" },
      },
      {
        path: "tipos-evento",
        name: "EventTypesAdmin",
        component: () =>
          import("../admin/records/eventTypes/views/EventTypesView.vue"),
        meta: { title: "Tipos de Evento" },
      },
      {
        path: "dispositivos",
        name: "DevicesAdmin",
        component: () =>
          import("../admin/records/devices/views/DevicesView.vue"),
        meta: { title: "Dispositivos" },
      },
    ],
  },
];
